import { useState } from "react";
import { MessageSquareWarning, ClipboardCheck, TrendingUp } from "lucide-react";
import { RecordModule } from "@/components/RecordModule";
import { ComplaintTrend } from "@/components/ComplaintTrend";

export default function CustomerCare() {
  const [tab, setTab] = useState("complaints");
  return (
    <div className="space-y-4" data-testid="customer-care-page">
      <div className="flex gap-2" data-testid="customer-care-tabs">
        {[["complaints", "Customer Complaints", MessageSquareWarning], ["trend", "Complaint Trend", TrendingUp], ["audits", "Audit Reports", ClipboardCheck]].map(([k, l, I]) => <button key={k} className={`rounded-md px-4 py-1.5 text-sm font-bold border flex items-center gap-2 ${tab === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-600"}`} onClick={() => setTab(k)} data-testid={`customer-care-tab-${k}`}><I size={14} /> {l}</button>)}
      </div>
      {tab === "trend" ? <ComplaintTrend /> : tab === "complaints" ? <RecordModule key="c" name="customer-complaints" icon={MessageSquareWarning} subtitle="Customer complaints · CAPA tracking"
        kpis={(s) => [
          { title: "Complaints", value: s?.count, sub: `${s?.customers ?? 0} customer(s)` },
          { title: "Open", value: s?.open, status: s?.open ? "red" : "green", sub: "Not yet closed" },
          { title: "Qty affected", value: s?.amount, unit: "pcs" },
          { title: "Top status", value: s?.by_group?.[0]?.group || "—", sub: s?.by_group?.[0] ? `${s.by_group[0].count} case(s)` : "" },
        ]} />
        : <RecordModule key="a" name="customer-audits" icon={ClipboardCheck} subtitle="Customer audits · scores and NC closure"
          kpis={(s) => [
            { title: "Audits", value: s?.count, sub: `${s?.customers ?? 0} customer(s)` },
            { title: "Avg score", value: s?.avg_score ?? "—", unit: "%", status: s?.avg_score == null ? undefined : s.avg_score >= 90 ? "green" : s.avg_score >= 75 ? "amber" : "red" },
            { title: "NC major / minor", value: `${s?.nc_major ?? 0} / ${s?.nc_minor ?? 0}`, status: s?.nc_major ? "red" : s?.nc_minor ? "amber" : "green" },
            { title: "Open", value: s?.open, status: s?.open ? "amber" : "green", sub: "Not closed" },
          ]} />}
    </div>
  );
}
